import { type CSSObject, styled } from '@mui/material/styles';

type ApprovalLabelProps = {
  hasCreditScore: boolean;
  smallText?: boolean;
  additionalStyles?: CSSObject;
};

export const ApprovalLabel = styled('span')<ApprovalLabelProps>(props => {
  let color = props.theme.palette.blues.dark;
  if (props.hasCreditScore) {
    color = props.theme.palette.grey[500];
  }

  return {
    fontSize: props.smallText ? '0.75rem' : '1rem',
    color,
    display: 'block',
    padding: '4px 0',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    ...props.additionalStyles,
  };
});
